module.exports = __webpack_public_path__ + "static/media/AttendedTwentyFive.023356d0.png";